import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AssignmentFilterTopbar from './assignment_filter_topbar';
import AssignmentsTable from './assignments_table';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-3';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus, faProjectDiagram } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/loading_spinner';
import SearchPage from 'components/search_page';
import PageHeader from 'components/page_header';
import CsvDownloadButton from  'components/csv_download_button';

import { changePage } from './store/actions/query';
import { retrieveRecords, filterOptionsAsQueryParameter } from './store/actions/search';
import queryString from 'query-string';

export class Assignments extends React.Component {
  static propTypes = {
    assignments: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
    isFetchingAssignments: PropTypes.bool.isRequired,
    isFiltered: PropTypes.bool.isRequired,
    paths: PropTypes.shape({
      assignmentsCsvPath: PropTypes.string,
      emptyAssignmentImage: PropTypes.string.isRequired,
      newAssignment: PropTypes.string
    }).isRequired,
    query: PropTypes.shape({
      statusFilter: PropTypes.array.isRequired
    }).isRequired,
    retrieveRecords: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.retrieveRecords();
  }

  scrollPanel = React.createRef();

  handlePageChange = (page) => {
    this.props.onPageChange(page);
    this.props.retrieveRecords();
    this.scrollToTop();
  };

  render() {
    return (
      <React.Fragment>
        <SearchPage>
          <div className="results-tab-container">
            {this.renderPageHeader()}
            <AssignmentFilterTopbar />
            <div className="table-content">
              <div className="main-content" ref={this.scrollPanel}>
                {this.renderResults()}
                {this.renderPagination()}
              </div>
            </div>
          </div>
        </SearchPage>
      </React.Fragment>
    );
  }

  csvDownloadPath() {
    const filters = filterOptionsAsQueryParameter(this.props.query);
    const paramsQueryString = queryString.stringify(filters, { arrayFormat: 'bracket' });
    return `${this.props.paths.assignmentsCsvPath}?${paramsQueryString}`;
  }

  renderPageHeader() {
    return (
      <PageHeader
        iconDescription="Manage your existing Assignments or create new ones"
        iconName={faProjectDiagram}
        iconSize="lg"
        iconText="Assignments"
        iconType="icon"
      >
        <div className="pull-right row-eq-height">
          <CsvDownloadButton href={this.csvDownloadPath()} type="Button" />
          {this.props.paths.newAssignment &&
            <a className="btn btn-create" href={this.props.paths.newAssignment}>
              <span className="hidden-xs">New Assignment</span>
              <span className="visible-xs">
                <FontAwesomeIcon className="mr-2" icon={faPlus} />
                New
              </span>
            </a>}
        </div>
      </PageHeader>
    );
  }

  renderResults() {
    const { assignments, isFetchingAssignments, isFiltered, totalCount } = this.props;

    if (isFetchingAssignments) {
      return (
        <div className="centered-image">
          <LoadingSpinner />
        </div>
      );
    } else if (assignments.length > 0) {
      return (
        <AssignmentsTable />
      );
    } else if (totalCount === 0) {
      return (
        <div className="centered-image">
          {isFiltered ? this.renderNoResults() : this.renderNoAssignments()}
        </div>
      );
    }
  }

  renderNoResults() {
    return (
      <div className="no-results-panel" name="noResults">
        <FontAwesomeIcon className="text-muted mt-4" icon={faSearch} size="5x"/>
        <h4 className="mt-4">
          <strong className="text-lg">No results found</strong>
        </h4>
        <p className="text-muted mb-4">Search with different criteria or create a New Assignment</p>
      </div>
    );
  }

  renderNoAssignments() {
    const { emptyAssignmentImage, newAssignment } = this.props.paths;

    return (
      <div className="no-results-panel text-center" name="noAssignments">
        <img src={emptyAssignmentImage} />
        <h4 className="mt-4">
          <strong className="text-lg">You don't have any assignments yet!</strong>
        </h4>
        {newAssignment &&
          <p className="text-muted mb-4">
            Click&nbsp;
            <a href={newAssignment}>New Assignment</a>
            &nbsp;to get started
          </p>}
      </div>
    );
  }

  renderPagination() {
    if (!this.props.isFetchingAssignments) {
      if (this.props.assignments.length >= this.props.totalCount) return <div className="my-5" />;

      return (
        <div className="text-center">
          <UltimatePagination
            currentPage={this.props.currentPage}
            totalPages={this.props.totalPages}
            onChange={this.handlePageChange}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  const isFiltered = !(
    state.query.searchText === '' &&
    state.query.assignmentTypeFilter.length === 0 &&
    state.query.brokerFilter == null &&
    state.query.propertyTypeFilter.length === 0 &&
    state.query.statusFilter.length === 0
  );

  return {
    ...state.search.meta,

    assignments: state.search.assignments,
    isFetchingAssignments: state.search.isFetching,
    isFiltered,
    paths: state.paths,
    query: state.query
  };
};

const mapDispatchToProps = {
  onPageChange: changePage,
  retrieveRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(Assignments);
